import { cn } from '@ui-kit/utils';
import type { IconProps } from '@/components/icons/types';

const LoadingIcon = ({ className, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 150"
    fill="none"
    aria-hidden="true"
    className={cn('size-6 shrink-0', className)}
    {...props}
  >
    <circle cx="75" cy="75" r="67" stroke="currentColor" strokeOpacity="0.2" strokeWidth="16" />
    <path
      d="M141.8 74.8999C141.8 111.848 111.848 141.8 74.8999 141.8C37.9521 141.8 8 111.848 8 74.8999C8 37.9521 37.9521 8 74.8999 8"
      stroke="currentColor"
      strokeWidth="16"
      strokeLinecap="round"
    />
  </svg>
);

export default LoadingIcon;
